import { ColorOptions } from '@jfs/ui-new'
import Svg, { G } from 'react-native-svg'
import { convertHexToRGBA } from '../../../utils'

export const BottomPhone = ({ height, width, color }: { height: any; width: any; color: any }) => {
  return (
    <Svg id="BottomPhones" width={width} height={height} viewBox="0 0 64 76">
      <G id="BottomPhone" transform="translate(-570 -487)">
        <rect
          id="Rectangle_1074"
          data-name="Rectangle 1074"
          width="64"
          height="63"
          rx="31.5"
          transform="translate(570 494)"
          fill={convertHexToRGBA(color, 10) as ColorOptions}
        />
        <G
          id="Rectangle_1075"
          data-name="Rectangle 1075"
          transform="translate(580 487)"
          fill="#fff"
          stroke={convertHexToRGBA(color, 20) as ColorOptions}
          stroke-width="2">
          <rect width="44" height="76" rx="4" stroke="none" />
          <rect x="1" y="1" width="42" height="74" rx="3" fill="none" />
        </G>
        <G id="Group_3023" data-name="Group 3023">
          <G
            id="Rectangle_1087"
            data-name="Rectangle 1087"
            transform="translate(570 528)"
            fill="#fff"
            stroke={convertHexToRGBA(color, 20) as ColorOptions}
            stroke-width="2">
            <rect width="64" height="24" rx="12" stroke="none" />
            <rect x="1" y="1" width="62" height="22" rx="11" fill="none" />
          </G>
          <path
            id="Path_521"
            data-name="Path 521"
            d="M5.52-16.584v2.952l2.76-1.032.552,1.512L6-12.216,7.824-9.84l-1.3.96-1.8-2.472L2.928-8.88,1.656-9.84,3.48-12.216.72-13.152l.528-1.512L3.96-13.632v-2.952Zm9.528,0v2.952l2.76-1.032.552,1.512-2.832.936L17.352-9.84l-1.3.96-1.8-2.472-1.8,2.472L11.18-9.84,13-12.216l-2.76-.936.528-1.512,2.712,1.032v-2.952Zm9.528,0v2.952l2.76-1.032.552,1.512-2.832.936L26.88-9.84l-1.3.96-1.8-2.472L21.98-8.88l-1.272-.96,1.824-2.376-2.76-.936.528-1.512,2.712,1.032v-2.952Zm9.528,0v2.952l2.76-1.032.552,1.512-2.832.936L36.408-9.84l-1.3.96-1.8-2.472-1.8,2.472L30.24-9.84l1.824-2.376-2.76-.936.528-1.512,2.712,1.032v-2.952Z"
            transform="translate(582.932 552.732)"
            fill={color}
          />
        </G>
      </G>
    </Svg>
  )
}
